import type { FC } from "react";
import { Nav, Tab } from "react-bootstrap";

import { TopicBox } from "components";
import EnvelopesOverviewSimple from "components/EnvelopesOverview/EnvelopesOverviewSimple";

import type { ISubjectData } from "utils/sortTopics";

interface Props {
  data: ISubjectData[];
  fallbackText: string;
  showEnvelopes: boolean;
  hrefBase: string;
}

const SubjectsTab: FC<Props> = ({ data, fallbackText, showEnvelopes, hrefBase }) => {
  if (data.length === 0) return null;

  return (
    <Tab.Container defaultActiveKey={data[0]?.subjectName}>
      <Nav>
        {data.map(subject => (
          <Nav.Item key={subject.subjectName}>
            {subject.assignmentsCount === undefined ? (
              <Nav.Link eventKey={subject.subjectName} className={"flex-column text-center"}>
                <div>{subject.subjectName}</div>
                <div className="d-flex justify-content-center pb-1">
                  {showEnvelopes ? <EnvelopesOverviewSimple envelopes={subject.envelopes} /> : null}
                </div>
              </Nav.Link>
            ) : (
              <Nav.Link eventKey={subject.subjectName} className={"text-center envelope-counts"}>
                <div>{subject.subjectName}</div>
                <div className={`envelope-count envelope-count--default`}>{subject.assignmentsCount}</div>
              </Nav.Link>
            )}
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content className={`subjects tabs-${Math.max(data.length, 1)}`}>
        {data.map(subject => (
          <Tab.Pane key={subject.subjectName} eventKey={subject.subjectName}>
            {subject.themes.length === 0 ? (
              <p className={"mx-5 my-auto mt-sm-3 mb-sm-0 text-center"}>{fallbackText}</p>
            ) : (
              subject.themes?.map(theme => <TopicBox key={theme.id} theme={theme} hrefBase={hrefBase} />)
            )}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default SubjectsTab;
